import axios from "@commons/infra/http/axios/axios";

export const QaGameApi = {
    initEntry: () => axios.post('/api/qagame/entry'),
    participate: (answers) => axios.post('/api/qagame/entry/participate', {answers}),
    participateInRegistrationGame: () => axios.post('/api/qagame/registration-game/entry/participate')
}